import axios from "axios";

export class CommonAPIService {
  constructor() {
    this.api_url = process.env.VUE_APP_API_URL;
    this.loggedIn = false;
  }

  login(login, router, store, errors) {
    return axios
      .post(`${this.api_url}/api/users/login`, login)
      .then((response) => {
        const { user, signUpToken } = response.data;
        store.setUser(user);
        store.setLoggedIn(true);
        localStorage.setItem("jwtToken" + "", signUpToken);
        return { user, signUpToken };
      })
      .catch((e) => {
        errors.push(e);
        return { success: false, msg: "Login Failure" };
      });
  }

  postCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = this.api_url + url;
    return axios
      .post(fullUrl, parameters)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        throw error;
      });
  }

  postCallForFiles(url, formData) {
    const fullUrl = this.api_url + url;
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");
    return axios
      .post(fullUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  deleteCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = this.api_url + url;
    return axios
      .delete(fullUrl, parameters)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
      });
  }

  putCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = this.api_url + url;
    return axios
      .put(fullUrl, parameters)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        throw error;
      });
  }

  putCallForFiles(url, formData, router) {
    const fullUrl = this.api_url + url;
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");
    return axios
      .put(fullUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status === 401 && router) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }

  getCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    axios.defaults.timeout = 100000;
    const fullUrl = this.api_url + url;
    return axios
      .get(fullUrl, { params: parameters })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        throw error;
      });
  }
}

export default CommonAPIService;
